let p;

// Memoized so multiple blocks on one page share a single dynamic import of
// the Vidstack player. Resolves once <media-player> is registered.
export function loadVidstack() {
  if (!p) {
    p = import("vidstack/player").then(() =>
      customElements.whenDefined("media-player"),
    );
  }
  return p;
}

// Point Vidstack's HLS provider at the hls.js we already bundle instead of its
// default jsDelivr CDN fetch (HLSProvider.library). `() => import("hls.js")`
// matches Vidstack's HLSConstructorLoader type ({ default: Hls }) and stays a
// lazy chunk, so non-HLS pages never download it. Must be wired before any src
// is assigned. On Safari/iOS Vidstack uses native HLS and this never fires.
export function useBundledHls(player) {
  player.addEventListener("provider-change", (e) => {
    const provider = e.detail;
    if (provider?.type === "hls") provider.library = () => import("hls.js");
  });
}
